type IdleHandle = { cancel: () => void }

interface IdleWindow extends Window {
  requestIdleCallback?: (
    callback: () => void,
    options?: { timeout: number }
  ) => number
  cancelIdleCallback?: (handle: number) => void
}

/**
 * Runs non-critical work once the page has finished loading and the main
 * thread is idle, so it never competes with first paint on mobile.
 */
export function runWhenIdle(callback: () => void, timeout = 2000): IdleHandle {
  let idleHandle: number | null = null
  let timeoutHandle: number | null = null
  let cancelled = false

  function schedule() {
    if (cancelled) return
    const idleWindow = window as IdleWindow
    if (typeof idleWindow.requestIdleCallback === 'function') {
      idleHandle = idleWindow.requestIdleCallback(callback, { timeout })
    } else {
      timeoutHandle = window.setTimeout(callback, 200)
    }
  }

  function onLoad() {
    schedule()
  }

  if (document.readyState === 'complete') {
    schedule()
  } else {
    window.addEventListener('load', onLoad, { once: true })
  }

  return {
    cancel() {
      cancelled = true
      window.removeEventListener('load', onLoad)
      const idleWindow = window as IdleWindow
      if (idleHandle !== null && typeof idleWindow.cancelIdleCallback === 'function') {
        idleWindow.cancelIdleCallback(idleHandle)
      }
      if (timeoutHandle !== null) window.clearTimeout(timeoutHandle)
    }
  }
}
